import { render } from "./SamplingPointConfig.view.vue?vue&type=template&id=3fd4f8dd&scoped=true&ts=true"
import script from "./SamplingPointConfig.view.vue?vue&type=script&lang=ts"
export * from "./SamplingPointConfig.view.vue?vue&type=script&lang=ts"

import "./SamplingPointConfig.view.vue?vue&type=style&index=0&id=3fd4f8dd&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd4f8dd"]])

export default __exports__